'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasl';
var iconName = 'knife-kitchen';
var width = 576;
var height = 512;
var aliases = [128298];
var unicode = 'f6f5';
var svgPathData = 'M553.4 118.6L576 96c-10.4-10.4-34.9-34.9-73.4-73.4L480 0 457.4 22.6 294.6 185.4 272 208c2.6 2.6 42.6 42.6 120 120l72-56 0-64 89.4-89.4zM432 208l0 48.3-37.3 29-77.4-77.4 162.7-162.7 50.7 50.7-89.4 89.4-9.4 9.4 0 13.3zM249.4 230.6L23.4 456.6 0 480s11.2 7.5 30 15.2c20.1 8.3 48.9 16.8 82 16.8 118.8 0 216.3-75.7 258.6-114.7l1.2-1.1c13.9-12.9 21.4-21.5 21.4-21.5-4-4-14.7-14.7-32-32l.1-.1-22.6-22.6-22.7 22.7c17.3 17.3 27.9 28 31.9 31.9-12.9 11.8-31 27-53.4 42.3-47.6 32.5-111.6 63.1-182.6 63.1-21.5 0-41.1-4.3-57.1-9.7L272 253.3 249.4 230.6zM448 144a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm32-32a16 16 0 1 0 0-32 16 16 0 1 0 0 32z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faKnifeKitchen = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;